/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  StrategyRecursiveFarming,
  StrategyRecursiveFarmingInterface,
} from "../StrategyRecursiveFarming";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_aavePoolAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_gasPriceFeedAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_wavaxAddr",
        type: "address",
      },
      {
        internalType: "address",
        name: "_aaveRewardsManager",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_interval",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "userAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quotas",
        type: "uint256",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "userAddr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quotas",
        type: "uint256",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "_investments",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quotas",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "checkUpkeep",
    outputs: [
      {
        internalType: "bool",
        name: "upkeepNeeded",
        type: "bool",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "doRecursion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getQuotaPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "getQuotaQty",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "interval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "performUpkeep",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_quotas",
        type: "uint256",
      },
    ],
    name: "requestWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardsManager",
    outputs: [
      {
        internalType: "contract IRewardsController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "token",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenAddresses",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalInvested",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_interval",
        type: "uint256",
      },
    ],
    name: "updateInterval",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "viewStatus",
    outputs: [
      {
        internalType: "enum StrategyRecursiveFarming.StrategyStatus",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_userAddr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class StrategyRecursiveFarming__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _aavePoolAddr: string,
    _gasPriceFeedAddr: string,
    _wavaxAddr: string,
    _aaveRewardsManager: string,
    _interval: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<StrategyRecursiveFarming> {
    return super.deploy(
      _aavePoolAddr,
      _gasPriceFeedAddr,
      _wavaxAddr,
      _aaveRewardsManager,
      _interval,
      overrides || {}
    ) as Promise<StrategyRecursiveFarming>;
  }
  getDeployTransaction(
    _aavePoolAddr: string,
    _gasPriceFeedAddr: string,
    _wavaxAddr: string,
    _aaveRewardsManager: string,
    _interval: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _aavePoolAddr,
      _gasPriceFeedAddr,
      _wavaxAddr,
      _aaveRewardsManager,
      _interval,
      overrides || {}
    );
  }
  attach(address: string): StrategyRecursiveFarming {
    return super.attach(address) as StrategyRecursiveFarming;
  }
  connect(signer: Signer): StrategyRecursiveFarming__factory {
    return super.connect(signer) as StrategyRecursiveFarming__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): StrategyRecursiveFarmingInterface {
    return new utils.Interface(_abi) as StrategyRecursiveFarmingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): StrategyRecursiveFarming {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as StrategyRecursiveFarming;
  }
}
